import { call, put } from "@redux-saga/core/effects";
import { toast } from "react-toastify";
import {
  requestDeleteWSClient,
  requestSaveWSClient,
  requestWSClients,
} from "../requests/authorizationRequest";
import {
  GET_WS_CLIENTS,
  setWSClients,
} from "../../reducers/authorizationReducer";
import confirmSaga from "./modalSagas";
import { handleError } from "../../../util/errorHandler";
import i18n from "../../../i18n/i18n";
import { setLoading } from "../../reducers/loadingReducer";

export function* handleGetWSClients(): any {
  try {
    yield put(setLoading(true));
    const response = yield call(requestWSClients);
    yield put(setWSClients(response.data));
  } catch (error: any) {
    yield handleError(error);
  } finally {
    yield put(setLoading(false));
  }
}

export function* handleSaveWSClient(action: any): any {
  try {
    yield call(requestSaveWSClient, action.params);
    toast.success(String(i18n.t("toasts.WSClientSaved")));
    yield put({ type: GET_WS_CLIENTS });
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteWSClient(action: any): any {
  try {
    yield call(requestDeleteWSClient, action.params);
    toast.success(String(i18n.t("toasts.WSClientDeleted")));
    yield put({ type: GET_WS_CLIENTS });
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleDeleteWSClientModal(action: any): any {
  try {
    const isConfirmed = yield call(confirmSaga, "delete");
    if (isConfirmed) {
      yield call(handleDeleteWSClient, action);
    }
  } catch (error: any) {
    yield handleError(error);
  }
}
